
import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { ErrorBlock, Toast } from 'antd-mobile'
import err from './images/err.png'
import './index.scss'

interface AiErrorBlockProps {
    image?:string
    visible?:boolean
    title?:React.ReactNode | string
    description?:React.ReactNode | string
    children?:React.ReactNode | string // 右上角的图标
    style?:any
    retry?:() => void
}

export class AiErrorBlock extends React.Component<AiErrorBlockProps, any> {
    static defaultProps = {
        image:'',
        visible:false,
        title:'',
        style:{},
        description:'网络不给力，请检查网络设置后重试',
        retry: () => {} // 重试按钮
    }
    constructor(props: AiErrorBlockProps) {
        super(props);
    }
    async handleRetry() {
        if(this.props.retry) {
            this.props.retry()
        }
    }
    render() {
        const { image, title, description, children, style } = this.props
        return (
            <div className='error-wrapper'>
                <ErrorBlock
                    image={image || err}
                    style={{
                        '--image-height': '2.1333rem',
                        '--image-width': '2.24rem',
                        paddingBottom:'1.5467rem',
                        width:'100%',
                        display: 'flex',
                        flexFlow: 'column',
                        alignItems: 'center',
                        justifyContent:'center',
                        height: 'calc(100vh - 2.4533rem)',
                        background: '#fff',
                        ...style
                    }}
                    title={title}
                    description={description}
                >
                    {children || <div className='err-btn' onClick={this.handleRetry.bind(this)}>重新加载</div>}
                </ErrorBlock>
            </div>
        )
    }
    handleLoad() {
        if( document.getElementById("technical") ) {
            document.getElementById("technical").style.background = '#fff'
        }
    }
    componentDidMount() {
        if( document.getElementById("technical") ) {
            document.getElementById("technical").style.background = '#fff'
        }else {
            window.addEventListener("load", this.handleLoad.bind(this))
        }
    }
    componentWillUnmount() {
        if( document.getElementById("technical") ) {
            document.getElementById("technical").style.background = ''
        }
        window.removeEventListener("load", this.handleLoad.bind(this))
    }
}


export default AiErrorBlock

export const aiErrorBlock = (options, getContainer) => {
    const err = document.getElementById("err")
    if (err) {
        err.remove()
    }
    let div = document.createElement('div');
    div.id = 'err';
    (getContainer || document.body).appendChild(div);
     // 销毁元素
     const destroy = () => {
        ReactDOM.render(null, div);
        (getContainer || document.body).removeChild(div)
    }
    const AiErrorBlockHook = (props) => {
        const handleRetry = async () => {
            try {
                Toast.show({
                    icon: 'loading',
                    content: '加载中…',
                    duration:0
                })
                const data = await options.retry()
                Toast.clear()
                destroy()
            } catch (error) {
                Toast.clear()
            }
        }
        return <AiErrorBlock  {...options} retry={handleRetry}  />
    }

    ReactDOM.render(<AiErrorBlockHook />, div)
}

